module.exports = __webpack_public_path__ + "media/images/springbig_leaf_logo-7548a996.png";